module.exports = __webpack_public_path__ + "img/17-12.04c5afaf.jpg";